<div class="content" [class.no-user]="!user">
  <div *ngIf="locale == locales.en">
    <h1>Privacy Policy</h1>
    <h2>Introduction</h2>
    <p>In the context of the accelerated development of new means of communication, protecting people&rsquo;s privacy is
      more important than ever. We are consequently committed to respecting the confidentiality of the personal
      information we collect in connection with our service&rsquo;s operation.</p>
    <h2>Collection of personal data</h2>
    <p>We collect the following data from our users:</p>
    <ul>
      <li>username</li>
      <li>e-mail address</li>
      <li>last name</li>
      <li>first name</li>
      <li>birth date</li>
      <li>gender</li>
      <li>mother tongue</li>
      <li>country of residence</li>
      <li>profile picture</li>
    </ul>
    <p>Personal data includes all information that a user voluntarily provides when registering on the website
      <app-link [href]="serviceUrl" class="link" [label]="serviceUrl" [external]="true"></app-link>
      , and which is collected in the context of their use of the
      site.
    </p>
    <p>Under the descriptive term &ldquo;data&rdquo; are included both &ldquo;registration data&rdquo; and &ldquo;usage
      data,&rdquo; as described below:</p>
    <p>Registration data refers to the information in the data fields that the user fills in when creating their QuizWin
      user account. Filling in some of these data fields is mandatory to have access to all site features. Currently,
      this
      includes information such as username, first and last name, birth date, gender, e-mail address, mother tongue, and
      country of residence.</p>
    <p>None of this information will be made public.</p>
    <p>It is the user&rsquo;s responsibility to ensure that the information allowing the site to identify and
      communicate
      with that user is accurate and up to date.</p>
    <p>The Teacher, Coordinator, and the organization Administrator may have access to a User&rsquo;s first name, last
      name, e-mail address (where this has been provided), assignment scores, assessment test results, and site usage
      statistics.</p>
    <p>The personal data we collect is stored in a secure environment.</p>
    <h2>Use of personal data collected on the site</h2>
    <p>The
      <app-link [href]="serviceUrl" class="link" [label]="serviceUrl" [external]="true"></app-link>
      website processes personal data to allow users to fully
      enjoy the services offered by the site and help us continuously improve the user experience. The use of this data
      allows QuizWin to:
    </p>
    <ul>
      <li>Create user accounts on QuizWin in order to provide users with various type is of site functionality</li>
      <li>respond to written requests sent to
        <app-link [href]="supportEmail" class="link" [label]="supportEmailLabel" [external]="true"></app-link>
      </li>
      <li>send a newsletter</li>
      <li>measure the audience of the site (via Google Analytics)</li>
    </ul>
    <p>The collection, recording, processing, and use of these data is implemented anonymously in order to generate
      service usage statistics that help us continuously improve the website. No individual user profile is
      generated.</p>
    <h2>Destination of personal data collected on the site</h2>
    <p>The data collected at registration is intended for QuizWin. However, the user informed that data might be
      disclosed
      as required by law, regulation, or pursuant to the decision of a competent regulatory or judicial authority.</p>
    <p>If the user has agreed to receive commercial offers from our partners electronically at the registration process,
      his or her registration data can be transmitted to our partners.</p>
    <p>At any time, the user can inform us that he or she no longer wants to receive commercial offers from our partners
      electronically by changing the settings of his or her user account.</p>
    <p>The User may also request that QuizWin stop sending its weekly User newsletter and promotional e-mails via the
      opt-out button displayed on the e-mail with which these items are sent. Users can also send a request to
      discontinue
      these messages by writing an email (stating your site user details - username and/or e-mail address used to create
      your user account) to:</p>
    <ul>
      <li>
        <app-link [href]="supportEmail" class="link" [label]="supportEmailLabel" [external]="true"></app-link>
      </li>
    </ul>
    <h2>Retention of data collected on the site</h2>
    <p>In the application of the &ldquo;right to be forgotten&rdquo; after a user account is disabled for any reason,
      the
      registration data associated with that account will be deleted within 12 months following the date of deactivation
      of the QuizWin account.</p>
    <p>All in all, QuizWin accounts inactive for a period equal or greater to 6 months may be disabled, with all related
      registration information deleted.</p>
    <p>Concerning the storage of data collected by the Google Analytics audience measurement tool, we invite the user to
      consult the privacy policy of Google Inc.</p>
    <p>QuizWin guarantees the confidentiality of the information stored on the site. The e-mail addresses and name data
      of
      registered users are not displayed on the site at any time.</p>
    <h2>Your rights</h2>
    <p>We bring to your attention your rights as a data user, which are regulated by the Law of Ukraine &ldquo;On
      Protection of Personal Data&rdquo;, namely:</p>
    <ol>
      <li>to know about the sources of collection, the location of personal data, the purpose of processing, the
        location
        or place of residence (stay) of the owner or manager of the personal data, or to give appropriate instruction
        for
        receiving this information by authorized persons, except in cases established by law;
      </li>
      <li>receive information about the conditions of access to personal data, in particular, information about third
        parties to whom personal user data is transferred;
      </li>
      <li>access to own personal data;</li>
      <li>receive no later than 30 (thirty) calendar days from the date of request, except in cases provided for by law,
        whether personal data is processed, and receive the contents of such personal data;
      </li>
      <li>make a reasoned request to an owner of personal data with an objection to the processing of personal data;
      </li>
      <li>to make a reasoned request to change or delete personal data by any owner and manager of personal data, if
        such
        data is processed illegally or is unreliable;
      </li>
      <li>to protect personal data from unlawful processing and accidental loss, destruction, damage due to intentional
        concealment, failure to provide or timely disclosure thereof, as well as to protect against the provision of
        information that is inaccurate or degrading honor, dignity, and goodwill an individual;
      </li>
      <li>to complain about the processing of personal data to the Ombudsman of Verkhovna Rada or to the court;</li>
      <li>include a clause in case of violation of the legislation on protection of personal data;</li>
      <li>make reservations regarding the restriction of the right to process their personal data when giving consent;
      </li>
      <li>withdraw consent to the processing of personal data;</li>
      <li>know the mechanism of automatic processing of personal data;</li>
      <li>protection against an automated decision that has legal consequences for it.</li>
    </ol>
    <p>For updating, accessing, modifying, blocking, or deleting personal data, withdraw consent to personal data
      processing provided by a user in accordance with this Policy, or in case of any comments, requests, or claims
      regarding personal data, please contact us by e-mail
      <app-link [href]="supportEmail" class="link" [label]="supportEmailLabel" [external]="true"></app-link>
      .
    </p>
    <p>However, we reserve the right to take the precaution of checking the identity of people who contact us (via
      requesting proof of identity) before allowing them to access personal data or to implement their account
      corrections.</p>
    <h2>Use of cookies on the site</h2>
    <p>The process of registering usernames and passwords required to access QuizWin initiates the creation of a cookie
      stored on the hard disk of the user&rsquo;s computer.</p>
    <p>This cookie allows you to use the "automatic connection" feature, which saves the username and password locally
      on
      your computer in encrypted form.</p>
    <p>At the next visit, this avoids the need for the user to perform a new log-in to use the site services. These
      cookies constitute anonymous and aggregated data and are in no way designed in such a way as to collect personal
      data.</p>
    <h2>Session cookies used for statistical purposes</h2>
    <p>For reasons related to the technology used by our providers, visiting our site will, where possible, involve the
      use of a session cookie for purposes of statistical analysis and site audience measurement.</p>
    <p>In accordance with Article 8.1 of the Terms and Conditions of the Google Analytics service, we draw the attention
      of our users to the following statement:</p>
    <p>&ldquo;This website uses Google Analytics, a web analytics service provided by Google Inc. ( "Google"). Google
      Analytics uses cookies, which are text files placed on your computer to help the website analyze site usage by its
      users. The data generated by the cookie about your use of the website (including your IP address) is transmitted
      and
      stored by Google on servers in the United States. Google will use this information to evaluate your use of the
      website, compiling reports on website activity addressed to its editor and providing other services relating to
      website activity and internet use. Google may also transfer this information to third parties where required by
      law
      or where such third parties process the information on Google's behalf, including, in particular, the editor of
      this
      site. Google will not associate your IP address with other Google data.</p>
    <p>You can disable the use of cookies by selecting the appropriate settings on your browser. However, this
      deactivation could prevent the use of some features of this website.</p>
    <p>Internet Explorer:</p>
    <p>
      <app-link
        href="https://support.microsoft.com/en-us/topic/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
        class="link"
        label="https://support.microsoft.com/en-us/topic/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
        [external]="true"></app-link>
    </p>
    <p>Firefox:</p>
    <p>
      <app-link
        href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies?esab=a&amp;s=cookies&amp;r=0&amp;as=s"
        class="link"
        label="https://support.mozilla.org/fr/kb/activer-desactiver-cookies?esab=a&amp;s=cookies&amp;r=0&amp;as=s"
        [external]="true"></app-link>
    </p>
    <p>Safari:</p>
    <p>
      <app-link
        href="https://support.apple.com/kb/index?page=search&amp;fac=all&amp;q=cookies%20safari"
        class="link"
        label="https://support.apple.com/kb/index?page=search&amp;fac=all&amp;q=cookies%20safari"
        [external]="true"></app-link>
    </p>
    <p>Chromium:</p>
    <p>
      <app-link
        href="https://support.google.com/chrome/answer/95647?hl=fr"
        class="link"
        label="https://support.google.com/chrome/answer/95647?hl=fr"
        [external]="true"></app-link>
    </p>
    <h2>Security</h2>
    <p>The personal information we collect is kept in a secure environment within the European Union; access to this
      information is limited to the Management of the company and the site developers.</p>
    <p>People who work for us are obliged to respect the confidentiality of your information.</p>
    <p>We are committed to maintaining a high degree of confidentiality by integrating the latest technological
      innovations to ensure the confidentiality of your transactions.</p>
    <p>However, as no mechanism offers maximum security, some risk is always present when using the internet to transmit
      personal information.</p>
  </div>

  <div *ngIf="locale != locales.en">
    <h1>Політика Конфіденційності</h1>
    <h2>Введення</h2>
    <p>З огляду на стрімкий розвиток нових засобів спілкування, захист особистої приватності стає ще більш важливим. Ми
      постійно працюємо над збереженням конфіденційності персональної інформації, яку ми збираємо на нашому сайті.</p>
    <h2>Збір персональних даних</h2>
    <p>Ми збираємо наступні дані у наших користувачів:</p>
    <ul>
      <li>ім'я користувача</li>
      <li>e-mail адреса</li>
      <li>прізвище</li>
      <li>ім'я</li>
      <li>дата народження</li>
      <li>стать</li>
      <li>рідна мова</li>
      <li>країна резидентства</li>
      <li>зображення профілю</li>
    </ul>
    <p>Персональні дані включають всю інформацію, яку користувач добровільно надає під час реєстрації на сайті
      <app-link [href]="serviceUrl" class="link" [label]="serviceUrl" [external]="true"></app-link>
      та яка збирається під час його користування сайтом.
    </p>
    <p>Під терміном "дані" маються на увазі "реєстраційні дані" та "дані про використання" згідно з описом нижче:</p>
    <p>Реєстраційні дані - це інформація, вказана у відповідних полях, яку вводить користувач під час створення свого
      акаунту користувача QuizWin. Заповнення деяких з цих полів є обов'язковим для отримання повного доступу до всіх
      функцій сайту. На даний момент, цією інформацією є ім'я користувача, прізвище та ім'я, дата народження, стать,
      e-mail адреса, рідна мова та країна резидентства.</p>
    <p>Ця інформація не буде видима іншим.</p>
    <p>Користувач відповідальний за те, що дані для його ідентифікації та спілкування з ним є точними та
      актуальними.</p>
    <p>Вчитель, Координатор та Адміністратор організації мають доступ до імені Користувача, його прізвища, email-адреси
      (де її було вказано), оцінок за завдання, результатів оціночних тестів та статистики користування сайтом.</p>
    <p>Персональні дані, які ми збираємо, зберігаються у безпечному середовищі.</p>
    <h2>Використання персональних даних, зібраних на сайті</h2>
    <p>Сайт
      <app-link [href]="serviceUrl" class="link" [label]="serviceUrl" [external]="true"></app-link>
      збирає персональні дані для того, щоб користувачі
      змогли у повній мірі користуватись послугами, запропонованими на сайті, а ми могли покращувати наш сервіс.
      Використання цих даних дає QuizWin змогу:
    </p>
    <ul>
      <li>Створювати акаунти користувачів на QuizWin для того, щоб забезпечити користувачів різноманітними функціями
        сайту
      </li>
      <li>відповідати на письмові запити, відправлені на
        <app-link [href]="supportEmail" class="link" [label]="supportEmailLabel" [external]="true"></app-link>
      </li>
      <li>здійснювати розсилку</li>
      <li>вимірювати кількість відвідувачів на сайті (через Google Analytics)</li>
    </ul>
    <p>Збір, запис, обробка та використання цих даних здійснюється анонімно, щоб згенерувати статистику користування
      сайтом, яка допоможе нам постійно покращувати наші послуги. Індивідуальні профілі користувачів не генеруються.</p>
    <h2>Призначення персональних даних, зібраних на сайті</h2>
    <p>Дані, зібрані під час реєстрації, призначені для QuizWin. Втім, користувач проінформований, що ці дані можуть
      бути розкриті за вимогою закону або згідно з рішенням компетентного регулюючого або судового органу.</p>
    <p>Якщо під час реєстраційного процесу користувач погодився отримувати електронним шляхом комерційні пропозиції від
      наших партнерів, його або її реєстраційні дані можуть бути передані нашим партнерам. Користувач може в будь-який
      час проінформувати нас, що він більше не бажає отримувати електронним шляхом комерційні пропозиції від наших
      партнерів, зробивши відповідні налаштування у своєму акаунті.</p>
    <p>Користувач має право відмовитися від отримання щотижневих листів для Користувача та email-листів з пропозиціями,
      натиснувши кнопку відмови у email-листі з подібною інформацією. Користувачі також можуть надіслати запит з
      проханням припинити відправлення листів, написавши нам на e-mail (зазначивши дані користувача на сайті - ім'я
      користувача та/або email-адресу, на яку зареєстровано акаунт):</p>
    <ul>
      <li>
        <app-link [href]="supportEmail" class="link" [label]="supportEmailLabel" [external]="true"></app-link>
      </li>
    </ul>
    <h2>Збереження даних, зібраних на сайті</h2>
    <p>Згідно з "правом на забуття", після припинення дії акаунту користувача з будь-якої причини, реєстраційні дані,
      асоційовані з цим акаунтом, будуть видалені протягом 12 місяців з моменту деактивації акаунту QuizWin.</p>
    <p>Загалом, акаунти QuizWin, які були неактивні протягом 6 місяців або більше, припиняють свою дію, а вся пов'язана
      з ними реєстраційна інформація видаляється.</p>
    <p>Щоб дізнатись більше про зберігання даних, зібраних за допомогою інструменту для вимірювання кількості
      відвідувачів Google Analytics, ми пропонуємо користувачу ознайомитися з політикою конфіденційності Google Inc.</p>
    <p>QuizWin гарантує конфіденційність даних, які зберігаються на сайті. E-mail адреси та дані про імена
      зареєстрованих користувачів ніколи не показані на сайті.</p>
    <h2>Ваші права</h2>
    <p>Ми доводимо до Вашого відома про Ваші права, як суб&rsquo;єкта персональних даних, які врегульовані Законом
      України &laquo;Про захист персональних даних&raquo;, а саме:&nbsp;</p>
    <ol>
      <li>знати про джерела збирання, місцезнаходження своїх персональних даних, мету їх обробки, місцезнаходження або
        місце проживання (перебування) володільця чи розпорядника персональних даних або дати відповідне доручення щодо
        отримання цієї інформації уповноваженим ним особам, крім випадків, встановлених законом;
      </li>
      <li>отримувати інформацію про умови надання доступу до персональних даних, зокрема інформацію про третіх осіб,
        яким передаються його персональні дані;
      </li>
      <li>на доступ до своїх персональних даних;</li>
      <li>отримувати не пізніш як за тридцять календарних днів з дня надходження запиту, крім випадків, передбачених
        законом, відповідь про те, чи обробляються його персональні дані, а також отримувати зміст таких персональних
        даних;
      </li>
      <li>пред&rsquo;являти вмотивовану вимогу володільцю персональних даних із запереченням проти обробки своїх
        персональних даних;
      </li>
      <li>пред&rsquo;являти вмотивовану вимогу щодо зміни або знищення своїх персональних даних будь-яким володільцем та
        розпорядником персональних даних, якщо ці дані обробляються незаконно чи є недостовірними;
      </li>
      <li>на захист своїх персональних даних від незаконної обробки та випадкової втрати, знищення, пошкодження у зв&rsquo;язку
        з умисним приховуванням, ненаданням чи несвоєчасним їх наданням, а також на захист від надання відомостей, що є
        недостовірними чи ганьблять честь, гідність та ділову репутацію фізичної особи;
      </li>
      <li>звертатися із скаргами на обробку своїх персональних даних до Уповноваженого Верховної Ради України з прав
        людини або до суду;
      </li>
      <li>застосовувати засоби правового захисту в разі порушення законодавства про захист персональних даних;</li>
      <li>вносити застереження стосовно обмеження права на обробку своїх персональних даних під час надання згоди;</li>
      <li>відкликати згоду на обробку персональних даних;</li>
      <li>знати механізм автоматичної обробки персональних даних;</li>
      <li>на захист від автоматизованого рішення, яке має для нього правові наслідки.</li>
    </ol>
    <p>Для оновлення, отримання доступу, внесення змін, блокування або видалення свої персональних даних, відкликання
      згоди на обробку персональних даних, які були Вами надані, відповідно до цієї Політики, або в разі наявності
      будь-яких зауважень, побажань або претензій щодо Ваших персональних даних, які обробляються, будь ласка,
      звертайтеся електронною поштою на
      <app-link [href]="supportEmail" class="link" [label]="supportEmailLabel" [external]="true"></app-link>
      .
    </p>
    <p>Ми залишаємо за собою право вживати заходи безпеки у формі перевірки особистості людей, які з нами зв'язуються
      (за допомогою дійсних документів, що засвідчують особу) перед тим, як давати їм доступ до персональних даних або
      зміни інформації в акаунті.</p>
    <h2>Використання куки-файлів на сайті</h2>
    <p>Процес реєстрації імен користувачів та паролів, необхідний для доступу до QuizWin, ініціює створення куки-файлів,
      які зберігаються на жорсткому диску комп'ютеру користувача.</p>
    <p>Ці куки-файли дають вам змогу користуватись функцією "автоматичне підключення" яка зберігає ім'я користувача та
      пароль локально на вашому комп'ютері в зашифрованій формі.</p>
    <p>Завдяки цьому, при наступному візиті вам не доведеться авторизуватись ще раз, щоб скористуватись послугами сайту.
      Ці куки-файли містять анонімні та сукупні дані і жодним чином не призначені для збору персональних даних.</p>
    <h2>Сесійні куки для статистичних цілей</h2>
    <p>У зв'язку з технологіями наших провайдерів, відвідування нашого сайту, по можливості, буде супроводжуватись
      використанням сесійних куки-файлів для статистичного аналізу та вимірювання аудиторії сайту.</p>
    <p>Згідно зі Статтею 8.1 Правил та Умов сервісу Google Analytics, ми звертаємо увагу наших користувачів на наступне
      твердження:</p>
    <p>"Цей веб-сайт використовує Google Analytics - аналітичний веб-сервіс від Google Inc. ("Google"). Google Analytics
      використовує куки, які являються текстовими файлами, зберігаються на вашому комп'ютері та допомагають власнику
      проаналізувати статистику користування його сайтом. Дані про ваше користування сайтом (включаючи вашу IP-адресу),
      згенеровані куки-файлами, передаються у Google та зберігаються на їх серверах у Сполучених Штатах. Google
      застосовує цю інформацію, щоб проаналізувати ваше користування сайтом та створити для редактора звіти про
      активність на сайті, а також надати інші послуги, пов'язані з активністю на сайті та використанням інтернету.
      Google також може передавати цю інформацію третім особам, якщо цього потребує закон, або треті особи діють від
      імені Google, включаючи, зокрема, редактора цього сайту. Google не асоціює вашу IP адресу з іншими даними
      Google.</p>
    <p>Ви можете вимкнути використання куки-файлів, зробивши відповідні налаштування у своєму браузері. Втім, вимкнення
      кук може обмежити доступ до деяких функцій цього сайту.</p>
    <p>Internet Explorer:</p>
    <p>
      <app-link
        href="https://support.microsoft.com/en-us/topic/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
        class="link"
        label="https://support.microsoft.com/en-us/topic/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d"
        [external]="true"></app-link>
    </p>
    <p>Firefox:</p>
    <p>
      <app-link
        href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies?esab=a&amp;s=cookies&amp;r=0&amp;as=s"
        class="link"
        label="https://support.mozilla.org/fr/kb/activer-desactiver-cookies?esab=a&amp;s=cookies&amp;r=0&amp;as=s"
        [external]="true"></app-link>
    </p>
    <p>Safari:</p>
    <p>
      <app-link
        href="https://support.apple.com/kb/index?page=search&amp;fac=all&amp;q=cookies%20safari"
        class="link"
        label="https://support.apple.com/kb/index?page=search&amp;fac=all&amp;q=cookies%20safari"
        [external]="true"></app-link>
    </p>
    <p>Chromium:</p>
    <p>
      <app-link
        href="https://support.google.com/chrome/answer/95647?hl=fr"
        class="link"
        label="https://support.google.com/chrome/answer/95647?hl=fr"
        [external]="true"></app-link>
    </p>
    <h2>Безпека</h2>
    <p>Персональна інформація, яку ми збираємо, зберігається у безпечному середовищі в межах Європейського Союзу; доступ
      до цієї інформації мають лише Керівництво компанії та розробники сайту.</p>
    <p>Люди, які з нами працюють, зобов'язані поважати конфіденційність вашої інформації.</p>
    <p>Ми забезпечуємо високий рівень конфіденційності завдяки інтеграції останніх технологічних рішень, щоб захистити
      приватність ваших транзакцій.</p>
    <p>Втім, оскільки жоден механізм не здатен забезпечити стовідсоткову безпеку, певна доля ризику присутня завжди,
      якщо персональна інформація передається через інтернет.</p>
  </div>
</div>
